import { BaseTLTableComponent, AxiosResponse, tlISODateToLocalString, tlISODateTimeToLocalNoSecondsString, SellerService, SellerFilter, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class SellerListBase extends BaseTLTableComponent {

	protected sellerService: SellerService = new SellerService();

	callActionClick() {
		this.isBusy = true;
		this.deleteItemsList = this.getSelectedList();
		super.deleteList();
		this.itemsSelected = null;
		(this.$refs.sellerTable as BaseTLTableBase).clearSelected();
	
	}

	getOptionalParams() {
		const getLastValidFromItem = (data: any[]) => {
			return data.reduce((latest: any, item: any) => {
					return !latest || new Date(item.validFrom) > new Date(latest.validFrom) ? item : latest;
				}, null);
		};

		const lastValidFromItem = getLastValidFromItem(this.tableData);
		
		return { item: lastValidFromItem ? lastValidFromItem : {} };
	}

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.sellerService.deleteList(this.deleteItemsList);
	}

	protected contentModal = this.$t('seller.messageQuestionMain').toString();

	deleteItem = 0;
	protected showAlertBeforeDeleteBase(itemsSelected: any) {	
		this.deleteItem = Number(itemsSelected);	
		this.showAlertBeforeActionClickBase(itemsSelected, this.$t('seller.messageQuestionMain').toString());		
	}

	protected setFields() {
		this.fields = [
			//{ key: 'id', label: this.$t('seller.fieldIdentif'), trans: 'seller.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'name', label: this.$t('seller.fieldName'), trans: 'seller.fieldName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('seller.fieldDescription'), trans: 'seller.fieldDescription', sortable: true, visible: true, class: 'text-center' },
			{ key: 'validFrom', label: this.$t('seller.fieldDateFrom'), trans: 'seller.fieldDateFrom', sortDirection: 'asc', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'validTo', label: this.$t('seller.fieldDateTo'), trans: 'seller.fieldDateTo', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'ic', label: this.$t('seller.fieldIC'), trans: 'seller.fieldIC', sortable: true, class: 'text-center' },
			{ key: 'dic', label: this.$t('seller.fieldDIC'), trans: 'seller.fieldDIC', sortable: true, class: 'text-center' },
			{ key: 'addressStreet', label: this.$t('seller.fieldStreet'), trans: 'seller.fieldStreet', sortable: true, class: 'text-center' },
			{ key: 'addressDistrict', label: this.$t('seller.fieldDistinct'), trans: 'seller.fieldDistinct', sortable: true, class: 'text-center' },
			{ key: 'addressCity', label: this.$t('seller.fieldCity'), trans: 'seller.fieldCity', sortable: true, class: 'text-center' },
			{ key: 'addressPostaCode', label: this.$t('seller.fieldPostalCode'), trans: 'seller.fieldPostalCode', sortable: true, class: 'text-center' },

			{ key: 'actions', label: this.$t('seller.fieldAction'), trans: 'seller.fieldAction', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'name', label: this.$t('seller.fieldName'), trans: 'seller.fieldName', selected: false, value: null, type: 'text' },
				{ key: 'description', label: this.$t('seller.fieldDescription'), trans: 'seller.fieldDescription', selected: false, value: null, type: 'text' },
			];
		}
	}


	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let sellerFilter: SellerFilter = new SellerFilter(null);
		return this.sellerService.getAllByFilter(sellerFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}

	


	protected prepareItems(items: any[]) {
	};
}